var React = require('react');

function ArrowRightLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.30544 0.760254L13.7849 5.88951H0V8.09992H13.7849L8.30544 13.2292H11.598L17.4565 7.6836V6.30353L11.598 0.760254H8.30544Z","fill":"#fffef8"}));
}

ArrowRightLarge.defaultProps = {"viewBox":"0 0 18 14","fill":""};

module.exports = ArrowRightLarge;

ArrowRightLarge.default = ArrowRightLarge;
